module.exports = __webpack_public_path__ + "img/info-prod-aprovado.cd19f6b5.svg";